import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";

export const Faqs = () => {
  const faqsList = [
    {
      title: "Why should I start a campaign with DonorAssist?",
      detail:
        "NO, however there are some fee based services that you CAN select If you like us to help you with your marketing/promotions with your campaign.",
    },
    {
      title: "Why should I start a campaign with DonorAssist?",
      detail:
        "NO, however there are some fee based services that you CAN select If you like us to help you with your marketing/promotions with your campaign.",
    },
  ];
  return (
    <div className="container mx-auto my-10" draggable>
      <div className="flex justify-between">
        <div className=" text-primary text-5xl font-semibold pb-5">FAQs</div>
        <div className="text-primary text-xl font-semibold">
          Home {">"} FAQS
        </div>
      </div>
      {faqsList.map((item, index) => {
        return (
          <div style={{ marginBottom: "1rem", width: "100%" }}>
            <Accordion
              elevation={0}
              key={index}
              sx={{ background: "transparent" }}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-primary"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                }
                id="panel1a-header"
                style={{
                  borderBottom: "1px #005087 solid",
                }}
              >
                <Typography>
                  <span>{item.title}</span>
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <span>{item.detail}</span>
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        );
      })}
    </div>
  );
};

export const Pricing = () => {
  return (
    <div className="container mx-auto my-10 flex flex-col gap-10 px-4">
      <div className="flex justify-between items-center">
        <div className=" text-primary text-2xl lg:text-5xl font-semibold ">
          Pricing & Fees
        </div>
        <div className="text-primary lg:text-xl font-semibold">
          Home {">"} Pricing & Fees
        </div>
      </div>
      <div className="text-primary text-xs lg:text-4xl   flex justify-between items-center my-10">
        <div className="flex flex-col items-center gap-2">
          <div className="font-semibold">DonorAssist</div>
          <div className="text-dark font-bold">0%</div>
          <div className="font-semibold">No Platform Fee</div>
        </div>
        <div className="lg:text-4xl font-bold">+</div>
        <div className="flex flex-col items-center gap-2">
          <div className="font-semibold">Payment Processing</div>
          <div className="text-dark font-bold">4.9%</div>
          <div className="font-semibold">+$ 0.75 per Donation</div>
        </div>
        <div className="lg:text-4xl font-bold">=</div>
        <div className="flex flex-col items-center gap-2">
          <div className="font-semibold">Total</div>
          <div className="text-dark font-bold">4.9%</div>
          <div className="font-semibold">+ $ 0.75 per Donation</div>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row items-center gap-10">
        <div className="pl-4 flex flex-col gap-2">
          <ul className="-ml-3 text-2xl lg:text-4xl text-primary font-bold ">
            There is 2 Choices when making a donation
          </ul>
          <br />
          <br />
          <div className="text-xl lg:text-3xl text-primary font-semilight">
            The donor can incur the cost
          </div>
          <li className="list-decimal font-semibold">
            Recipient Receives $100! Donor Accepts Fees Donor is charged $105.65
            ($100+$4.90+$0.75)
          </li>
          <br />
          <br />
          <div className="text-xl lg:text-3xl text-primary font-semilight ">
            Have it deducted from their donation
          </div>
          <li className="list-decimal font-semibold">
            Recipient Receives $94.35 Donor Does Not Accept Fees ($100 -$4.90
            -$0.75)
          </li>
        </div>
        <img
          src={process.env.PUBLIC_URL + "assets/images/pricing.png"}
          alt="pricing"
          className="lg:w-2/4"
        />
      </div>
      <div>
        <div className="text-2xl lg:text-5xl font-bold text-primary">
          NO Platform Fee! Set-Up is FREE!
          <br />
          <br />
        </div>
        <div className=" lg:text-xl">
          As a Benefit Corporation, one of DonorAssist goals is to make a social
          impact on society. This platform is constantly reaching out to donors
          on the recipients behalf to help fund our platform and recipient
          campaigns.
          <br />
          <br /> We truly need everyones support. We greatly appreciate
          voluntary donor gratuity during the donation process; or you can also
          donate to our DonorAssist Fund to help support the functionality and
          maintenance of our platform.
          <br />
          <br /> *The above pricing applies for US merchant processing
          only…international merchant processing may have increased fees.
          <br />
          <br />
        </div>
        <div className="text-xl lg:text-3xl underline font-semibold underline-offset-8 decoration-primary">
          Thank you in advance for your support!
        </div>
      </div>
    </div>
  );
};
